import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';
import TooltipIconButton from 'components/ToolTipIconButton';
import { DateTime } from 'luxon';

import CalendarIcon from '@common/assets/icons/calendar-clock.svg';
import isDatePassed from '@common/helpers/isDatePassed';

interface PropsType {
	deadline: string;
}

function ProgramLessonDeadline({ deadline }: PropsType) {
	const { t } = useTranslation();

	if (!deadline) return null;

	const isDeadlinePassed = isDatePassed(deadline);

	const formattedDate = DateTime.fromISO(deadline).toFormat('dd.MM.yyyy');

	return (
		<TooltipIconButton
			title={
				<Typography variant="body2" color="text.primary">
					{t(isDeadlinePassed ? 'shared.deadlineWas' : 'shared.deadlineUntil', {
						date: formattedDate,
					})}
				</Typography>
			}
			color={isDeadlinePassed ? 'error' : 'info'}
		>
			<CalendarIcon />
		</TooltipIconButton>
	);
}

export default ProgramLessonDeadline;
